import { Chip } from '@nextui-org/react';
import { Icon } from '@iconify/react';

import { type SidebarItem } from './SidebarTypes';
import { Role } from 'common/src/utils/types';
import { ROUTES } from '../../../types/api';
import { ROLES } from '../../../types/constans';

/**
 * Please check the https://nextui.org/docs/guide/routing to have a seamless router integration
 */

export const sectionItemsWithDashboardAndTasks = (
  userRole: Role[],
  pendingTaskersCount: number
): SidebarItem[] => [
  {
    key: 'dashboard',
    title: 'Dashboard',
    startContent: <Icon icon="solar:home-2-linear" width={24} />,
    href: ROUTES.HOME_PAGE,
  },
  {
    key: 'tasks',
    title: 'Tasks',
    startContent: <Icon icon="solar:checklist-minimalistic-outline" width={24} />,
    href: ROUTES.TASK,
  },
  {
    key: 'automated-offers',
    title: 'Asignación Automática',
    startContent: <Icon icon="la:robot" width={24} />,
    href: ROUTES.AUTOMATED_OFFERS,
  },
  {
    key: 'tasks-management',
    title: 'Tasks Management',
    startContent: <Icon icon="solar:list-outline" width={24} />,
    href: ROUTES.TASK_MANAGEMENT,
  },
  {
    key: 'payments',
    href: ROUTES.PAYMENTS,
    icon: 'solar:bill-list-outline',
    title: 'Pagos a Taskers',
  },
  {
    key: 'task-calendar',
    title: 'Task Calendar',
    startContent: <Icon icon="solar:calendar-outline" width={24} />,
    href: ROUTES.TASK_CALENDAR,
  },
  {
    key: 'recurring-tasks',
    title: 'Tasks Recurrentes',
    startContent: <Icon icon="solar:repeat-outline" width={24} />,
    href: ROUTES.RECURRING_TASKS,
  },
  {
    key: 'pending-taskers',
    title: 'Taskers Pendientes',
    startContent: <Icon icon="solar:user-rounded-outline" width={24} />,
    href: ROUTES.ADMIN_PENDING_TASKERS,
    alwaysShowEndContent: true,
    endContent:
      pendingTaskersCount > 0 ? (
        <Chip size="sm" variant="flat" color="warning">
          {pendingTaskersCount}
        </Chip>
      ) : null,
  },
  {
    key: 'approved-taskers',
    title: 'Gestión de Taskers',
    startContent: <Icon icon="solar:user-check-rounded-outline" width={24} />,
    href: ROUTES.ADMIN_TASKERS,
  },
  ...(userRole.includes(ROLES.ADMIN)
    ? [
        {
          key: 'manage-team',
          title: 'Tu Equipo',
          startContent: <Icon icon="solar:users-group-rounded-outline" width={24} />,
          href: ROUTES.TEAM,
        },
        {
          key: 'metrics',
          title: 'Metrics',
          startContent: <Icon icon="solar:chart-2-outline" width={24} />,
          href: ROUTES.METRICS,
        },
        {
          key: 'taskers',
          title: 'Taskers',
          startContent: <Icon icon="solar:user-rounded-outline" width={24} />,
          href: ROUTES.TASKERS,
        },
        {
          key: 'popup',
          title: 'Pop Up',
          startContent: <Icon icon="solar:popup-outline" width={24} />,
          href: ROUTES.POPUP,
        },
        {
          key: 'app-banners',
          title: 'App Banners',
          startContent: <Icon icon="solar:billboard-outline" width={24} />,
          href: ROUTES.APP_BANNERS,
        },
        {
          key: 'discount-coupons',
          title: 'Cupones de Descuento',
          startContent: <Icon icon="solar:ticket-outline" width={24} />,
          href: ROUTES.DISCOUNT_COUPONS,
        },
        {
          key: 'category-topics',
          title: 'Temas de categorías',
          startContent: <Icon icon="solar:folder-with-files-outline" width={24} />,
          href: ROUTES.CATEGORY_TOPICS,
        },
      ]
    : []),
];
